import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --badge-max-width: 300px;
    --badge-border-radius: var(--radius-sm, 5px);
    --badge-bg: transparent;
    --badge-border: var(--sm-line, 1.5px) solid var(--color-primary-dark);
    --icon-color: var(--color-dark-gray);
    --text-color: var(--color-primary-dark);
  }

  .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm);
    border-radius: var(--badge-border-radius);
    font-size: var(--badge-font-size, 0.75rem);
    padding: var(--spacing-sm);
    font-weight: var(--badge-font-weight, 600);
    background-color: var(--custom-bg-color, var(--badge-bg, var(--color-light-gray-1)));
    color: var(--custom-text-color, var(--text-color, var(--color-dark-gray-1)));
    border: var(--sm-line, 1.5px) solid var(--custom-border-color, var(--color-primary-dark));
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
  }

  :host([disabled]) .badge {
    opacity: 0.7;
    cursor: not-allowed;
  }

  /* Outline Style */
  :host([style-type="outline"]) .badge {
    background: var(--custom-bg-color, var(--badge-bg));
    border: var(--sm-line, 1.5px) solid var(--custom-border-color, var(--badge-border));
  }

  :host([style-type="outline"][state="default"]) .badge {
    border-color: var(--custom-border-color, var(--color-primary-dark));
  }
  :host([style-type="outline"][state="success"]) .badge {
    border-color: var(--color-success, #72b509);
  }
  :host([style-type="outline"][state="info"]) .badge {
    border-color: var(--color-secondary, #2594e3);
  }
  :host([style-type="outline"][state="warning"]) .badge {
    border-color: var(--color-warning, #ff9505);
  }
  :host([style-type="outline"][state="error"]) .badge {
    border-color: var(--color-error, #ff2b32);
  }
  :host([style-type="outline"][state="disabled"]) .badge {
    border-color: var(--color-gray-3, #d7d4d2);
  }

  :host([style-type="outline"]) .text,
  :host([style-type="outline"]) ::slotted([slot="text"]) {
    color: var(--text-color));
  }

  /* Filled Style */
  :host([style-type="filled"]) .badge {
    background: var(--custom-bg-color, var(--badge-bg));
    border: none;
  }

  :host([style-type="filled"][state="default"]) .badge {
    background: var(--custom-bg-color, var(--color-primary-dark));
  }
  :host([style-type="filled"][state="success"]) .badge {
    background: var(--color-success, #72b509);
  }
  :host([style-type="filled"][state="info"]) .badge {
    background: var(--color-secondary, #2594e3);
  }
  :host([style-type="filled"][state="warning"]) .badge {
    background: var(--color-warning, #ff9505);
  }
  :host([style-type="filled"][state="error"]) .badge {
    background: var(--color-error, #ff2b32);
  }
  :host([style-type="filled"][state="disabled"]) .badge {
    background: var(--color-gray-3, #d7d4d2);
  }

  :host([style-type="filled"]) .text,
  :host([style-type="filled"]) ::slotted([slot="text"]) {
    color: var(--custom-text-color, var(--color-white, #ffffff));
  }
`;